/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Delegation_Not_AllowedInputs */

const en_error_delegation_not_allowed = /** @type {(inputs: Error_Delegation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot manage access tokens from here: only a user of Tomorrow signed in to Backstage, with a role that gives them, can.`)
};

/**
* | output |
* | --- |
* | "You cannot manage access tokens from here: only a user of Tomorrow signed in to Backstage, with a role that gives them, can." |
*
* @param {Error_Delegation_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_delegation_not_allowed = /** @type {((inputs?: Error_Delegation_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Delegation_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_delegation_not_allowed(inputs)
});